import React from "react";

import Slider from "components/Inputs/Slider/Slider";

import styles from "./style.module.css";

export default class ChooseProcessLimit extends React.PureComponent {
  state = {
    showSlider: true
  };

  handleNoConstraints() {
    const { updateProcessLimit, total } = this.props;
    const { showSlider } = this.state;

    updateProcessLimit(total);
    return this.setState({ showSlider: !showSlider });
  }

  render() {
    const { total, isMini, processLimit, targeted, timePeriod, updateProcessLimit } = this.props;
    const { showSlider } = this.state;

    if (processLimit === undefined) {
      return <div />;
    }

    return (
      <div className={styles.sliders}>
        {showSlider && (
          <Slider
            label={"My new processing capacity is:"}
            min={0}
            max={total}
            value={processLimit}
            onChange={(val) => updateProcessLimit(val)}
            marks={{ [targeted]: "Current" }}
            className={styles.sliderHolder}
            endLabel={timePeriod ? "Transactions per " + timePeriod : "Transactions"}
            isWideLabel
            hideSlider={isMini}
          />
        )}
      </div>
    );
  }
}
